[
  {
    "code": "NP-7-ACH",
    "name": "Achham"
  },
  {
    "code": "NP-5-ARG",
    "name": "Arghakhanchi"
  },
  {
    "code": "NP-4-BAG",
    "name": "Baglung"
  },
  {
    "code": "NP-7-BAI",
    "name": "Baitadi"
  },
  {
    "code": "NP-7-BHA",
    "name": "Bajhang"
  },
  {
    "code": "NP-7-BUR",
    "name": "Bajura"
  },
  {
    "code": "NP-5-BAN",
    "name": "Banke"
  },
  {
    "code": "NP-2-BAR",
    "name": "Bara"
  },
  {
    "code": "NP-5-BAR",
    "name": "Bardiya"
  },
  {
    "code": "NP-3-BHA",
    "name": "Bhaktapur"
  },
  {
    "code": "NP-1-BHO",
    "name": "Bhojpur"
  },
  {
    "code": "NP-3-CHI",
    "name": "Chitawan"
  },
  {
    "code": "NP-7-DAD",
    "name": "Dadeldhura"
  },
  {
    "code": "NP-6-DAI",
    "name": "Dailekh"
  },
  {
    "code": "NP-5-DAN",
    "name": "Dang"
  },
  {
    "code": "NP-7-DAR",
    "name": "Darchula"
  },
  {
    "code": "NP-3-DHA",
    "name": "Dhading"
  },
  {
    "code": "NP-1-DHA",
    "name": "Dhankuta"
  },
  {
    "code": "NP-2-DHA",
    "name": "Dhanusha"
  },
  {
    "code": "NP-3-DOL",
    "name": "Dolakha"
  },
  {
    "code": "NP-6-DOL",
    "name": "Dolpa"
  },
  {
    "code": "NP-7-DOT",
    "name": "Doti"
  },
  {
    "code": "NP-4-GOR",
    "name": "Gorkha"
  },
  {
    "code": "NP-5-GUL",
    "name": "Gulmi"
  },
  {
    "code": "NP-6-HUM",
    "name": "Humla"
  },
  {
    "code": "NP-1-ILA",
    "name": "Ilam"
  },
  {
    "code": "NP-6-JAJ",
    "name": "Jajarkot"
  },
  {
    "code": "NP-1-JHA",
    "name": "Jhapa"
  },
  {
    "code": "NP-6-JUM",
    "name": "Jumla"
  },
  {
    "code": "NP-3-KAB",
    "name": "Kabhrepalanchok"
  },
  {
    "code": "NP-7-KAI",
    "name": "Kailali"
  },
  {
    "code": "NP-6-KAL",
    "name": "Kalikot"
  },
  {
    "code": "NP-7-KAN",
    "name": "Kanchanpur"
  },
  {
    "code": "NP-5-KAP",
    "name": "Kapilbastu"
  },
  {
    "code": "NP-4-KAS",
    "name": "Kaski"
  },
  {
    "code": "NP-3-KAT",
    "name": "Kathmandu"
  },
  {
    "code": "NP-1-KHO",
    "name": "Khotang"
  },
  {
    "code": "NP-3-LAL",
    "name": "Lalitpur"
  },
  {
    "code": "NP-4-LAM",
    "name": "Lamjung"
  },
  {
    "code": "NP-2-MAH",
    "name": "Mahottari"
  },
  {
    "code": "NP-3-MAK",
    "name": "Makawanpur"
  },
  {
    "code": "NP-4-MAN",
    "name": "Manang"
  },
  {
    "code": "NP-1-MOR",
    "name": "Morang"
  },
  {
    "code": "NP-6-MUG",
    "name": "Mugu"
  },
  {
    "code": "NP-4-MUS",
    "name": "Mustang"
  },
  {
    "code": "NP-4-MYA",
    "name": "Myagdi"
  },
  {
    "code": "NP-4-NAW",
    "name": "Nawalparasi East"
  },
  {
    "code": "NP-5-NAW",
    "name": "Nawalparasi West"
  },
  {
    "code": "NP-3-NUW",
    "name": "Nuwakot"
  },
  {
    "code": "NP-1-OKH",
    "name": "Okhaldhunga"
  },
  {
    "code": "NP-5-PAL",
    "name": "Palpa"
  },
  {
    "code": "NP-1-PAN",
    "name": "Panchthar"
  },
  {
    "code": "NP-4-PAR",
    "name": "Parbat"
  },
  {
    "code": "NP-2-PAR",
    "name": "Parsa"
  },
  {
    "code": "NP-5-PYU",
    "name": "Pyuthan"
  },
  {
    "code": "NP-3-RAM",
    "name": "Ramechhap"
  },
  {
    "code": "NP-3-RAS",
    "name": "Rasuwa"
  },
  {
    "code": "NP-2-RAU",
    "name": "Rautahat"
  },
  {
    "code": "NP-5-ROL",
    "name": "Rolpa"
  },
  {
    "code": "NP-5-RUK",
    "name": "Rukum East"
  },
  {
    "code": "NP-6-RUK",
    "name": "Rukum West"
  },
  {
    "code": "NP-5-RUP",
    "name": "Rupandehi"
  },
  {
    "code": "NP-6-SAL",
    "name": "Salyan"
  },
  {
    "code": "NP-1-SAN",
    "name": "Sankhuwasabha"
  },
  {
    "code": "NP-2-SAP",
    "name": "Saptari"
  },
  {
    "code": "NP-2-SAR",
    "name": "Sarlahi"
  },
  {
    "code": "NP-3-SLI",
    "name": "Sindhuli"
  },
  {
    "code": "NP-3-SPA",
    "name": "Sindhupalchok"
  },
  {
    "code": "NP-2-SIR",
    "name": "Siraha"
  },
  {
    "code": "NP-1-SOL",
    "name": "Solukhumbu"
  },
  {
    "code": "NP-1-SUN",
    "name": "Sunsari"
  },
  {
    "code": "NP-6-SUR",
    "name": "Surkhet"
  },
  {
    "code": "NP-4-SYA",
    "name": "Syangja"
  },
  {
    "code": "NP-4-TAN",
    "name": "Tanahu"
  },
  {
    "code": "NP-1-TAP",
    "name": "Taplejung"
  },
  {
    "code": "NP-1-TER",
    "name": "Terhathum"
  },
  {
    "code": "NP-1-UDA",
    "name": "Udayapur"
  }
]